import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionBiggestChallengePage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-learn-first')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionBiggestChallenge.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionBiggestChallenge.forgetWater'),
          value: 'forget_water',
        },
        {
          text: t('pages.onboarding.questionBiggestChallenge.plantsDying'),
          value: 'plants_dying',
        },
        {
          text: t('pages.onboarding.questionBiggestChallenge.dontKnowNeeds'),
          value: 'dont_know_needs',
        },
        {
          text: t(
            'pages.onboarding.questionBiggestChallenge.pestsDiseasesText',
          ),
          value: 'pests_diseases',
        },
        {
          text: t(
            'pages.onboarding.questionBiggestChallenge.identifyingPlants',
          ),
          value: 'identifying_plants',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
